import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'
import Cookies from 'js-cookie'
// import store from '@/store'
// import { getToken } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  // baseURL: 'http://192.168.28.225:8081', // 丁api的base_url
   // baseURL: 'http://192.168.100.161:11411/', // api的base_url
  // baseURL: 'http://192.168.28.137:8081', // 宗api的base_url
   baseURL: 'https://api.qdkjg.com.cn', // 郑api的base_ur
  // baseURL: 'http://192.168.100.161:11411/', // 测试环境
    // baseURL: 'http://10.100.1.7:10221/', // 测试环境
  // baseURL: 'http://192.168.10.3:10221/', // 局域网地址
  timeout: 5000000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  // Do something before request is sent
  //   if (store.getters.token) {
  if (config.headers['content-type']) {
    config.headers['content-type'] = config.headers['content-type']
  } else {
    config.headers['content-type'] = 'application/json'
  }
  if (Cookies.get('userInfoqd')) {
    if (JSON.parse(Cookies.get('userInfoqd')).token) {
      config.headers['token'] = JSON.parse(Cookies.get('userInfoqd')).token // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    }
  }
  //   }
  return config

}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    console.log()
    /**
    * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
    * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
    */
    const res = response.data;
    if (res.code == 403) {
      if (window.location.pathname && window.location.pathname != '/') {
        Cookies.remove('userAllInfoqd')
        Cookies.remove('userInfoqd')
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        });
        router.push({ name: 'Login' })
      } else if (window.location.pathname == '/') {
        Cookies.remove('userAllInfoqd')
        Cookies.remove('userInfoqd')
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        });
        router.push({ name: 'Index' })
      } else {
        Cookies.remove('userAllInfoqd')
        Cookies.remove('userInfoqd')
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        });
        router.push({ name: 'Index' })
      }

      // return Promise.reject('error');
      return response;
    } else if (res.code == 0) {
      return response;
    } else {
      if (window.location.pathname && window.location.pathname != '/') {
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        });
      }else{

      }

      return response;
      // return Promise.reject('error');
    }
  },
  error => {
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js